import { render, staticRenderFns } from "./search-filter.vue?vue&type=template&id=5851f572&"
import script from "./search-filter.vue?vue&type=script&lang=ts&"
export * from "./search-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports